import { render, staticRenderFns } from "./HuliOngoing.vue?vue&type=template&id=f0baf4b4&scoped=true"
import script from "./HuliOngoing.vue?vue&type=script&lang=js"
export * from "./HuliOngoing.vue?vue&type=script&lang=js"
import style0 from "./HuliOngoing.vue?vue&type=style&index=0&id=f0baf4b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0baf4b4",
  null
  
)

export default component.exports